// extracted by mini-css-extract-plugin
export default {"modal":"Thn9GTjxaLtMIenE3kCg","body":"KJyJ0dVdfFHVePvo7jJQ","cta":"dxdpK_ejjjUIPkzzfNri"};